import { useContext } from 'react';
import { ModalContext } from './modalContext';
import type { ModalControls } from './modalTypes';

/**
 * Open or close the app-wide modal: openModal(MODAL_KEYS.MERGE_CONFIRM, props) shows that modal
 * with those props. The props are fixed when the modal opens, so pass ids rather than data that
 * may change while it is open.
 */
export const useModal = (): ModalControls => useContext(ModalContext);
